import React, { useEffect, useState } from 'react'
import {
  Autocomplete,
  Box,
  TextField,
  Modal,
  ThemeProvider,
} from '@mui/material'
import { theme } from '../../muiTheme'
import { postData } from '../../../js/helpers/apiHelper'
import * as lib from '../../../js/lib/lib'

const CheckInModal = () => {
  const { configuration, dictionary, records } = window.checkInModalData

  const [open, setOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [redirectUrl, setRedirectUrl] = useState(null)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    const openButton = document.querySelectorAll(
      '[data-target="modalCheckInButton"]'
    )

    if (openButton) {
      openButton.forEach((button) => {
        button.addEventListener('click', handleOpen)
      })
    }
  }, [])

  const handleSelect = async (value) => {
    setSelectedOption(value)

    if (!value) {
      setRedirectUrl(null)
      return
    }

    try {
      setIsLoading(true)
      const payload = {
        country: value.value,
      }

      const response = await postData(
        configuration.endpointCountrySelected,
        payload
      )

      if (response.hasError) {
        handleError(response.errorMessages)
        return
      }

      if (!response.data.redirectUrl) {
        setRedirectUrl(null)
        return
      }

      setRedirectUrl(response.data.redirectUrl)
      handleSuccess()
    } catch (err) {
      console.error(err)
      handleError([err])
    }
  }

  const handleSuccess = () => {
    // setErrMsgs([])
    setIsLoading(false)
  }

  const handleError = (messages) => {
    // setErrMsgs(messages)
    setIsLoading(false)

    setTimeout(() => {
      lib.scrollToError(100)
    }, 0)
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Box>
        <div className="b-check-in-modal">
          <div className="b-check-in-modal__header">
            <button
              type="button"
              className="btn-clear b-check-in-modal__close"
              onClick={handleClose}
              aria-label="Close check-in modal">
              <i className="icon icon-x"></i>
            </button>
            <div className="b-check-in-modal__title">
              {dictionary.checkInModalTitle}
            </div>
            <div className="b-check-in-modal__subtitle">
              {dictionary.checkInModalSubtitle}
            </div>
          </div>
          <div className="b-check-in-modal__body">
            <label htmlFor="location">
              {dictionary.checkInModalInputLabel}
            </label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                options={records}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                value={selectedOption}
                onChange={(_, value) => handleSelect(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={dictionary.checkInModalInputPlaceholder}
                    variant="filled"
                  />
                )}
              />
            </ThemeProvider>
          </div>

          <div className="b-check-in-modal__footer">
            <a
              href={redirectUrl}
              type="submit"
              className="btn btn-primary btn-full-width"
              disabled={!redirectUrl}>
              {dictionary.checkInModalBtnText}
            </a>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default CheckInModal
